import ApiService from '@/services/ApiService'

export const namespaced = true

export const state = {
  accessTokens: []
}

export const mutations = {
  SET_ACCESS_TOKENS(state, accessTokens) {
    state.accessTokens = accessTokens
  },
  REVOKE_TOKEN(state, accessToken) {
    const index = state.accessTokens.findIndex(
      item => item.id === accessToken.id
    )
    if (index !== -1) {
      state.accessTokens.splice(index, 1, accessToken)
    }
  },
  CREATE_ACCESS_TOKEN(state, accessToken) {
    state.accessTokens.push(accessToken)
  }
}

export const actions = {
  fetchAccessTokens({ commit }) {
    return ApiService.fetchAccessTokens()
      .then(res => {
        const accessTokens = res.data
        commit('SET_ACCESS_TOKENS', accessTokens)
      })
      .catch(error => {
        throw error
      })
  },
  revokeToken({ commit }, accessToken) {
    return ApiService.revokeToken(accessToken)
      .then(res => {
        const accessToken = res.data
        commit('REVOKE_TOKEN', accessToken)
      })
      .catch(error => {
        throw error
      })
  },
  createAccessToken({ commit }, accessToken) {
    return ApiService.createAccessToken(accessToken)
      .then(res => {
        const accessToken = res.data
        commit('CREATE_ACCESS_TOKEN', accessToken)
        return accessToken
      })
      .catch(error => {
        throw error
      })
  }
}
